import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyData',
  standalone: true,
})
export class EmptyDataPipe implements PipeTransform {
  constructor() {}

  transform(value: any, placeholder: string = '--'): any {
    if (['', null, undefined].includes(value)) return placeholder;
    else if (typeof value === 'string' && value.trim() == '') return placeholder;
    else if (Array.isArray(value) && value.length == 0) return placeholder;
    else return value;
  }
}
